import {isDevEnv} from "@/utils/helpers";
import { PlanEnum } from "@/core/js/model/Subscription/Plans/PlanEnum.js";
import { PlanEnumDev } from "@/core/js/model/Subscription/Plans/PlanEnumDev.js";

/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 9.10.24
 *
 */
const devPlanMapObj = {
	//prodPlanId: devPlanId
	[PlanEnum.IFS_MAPPING_TRIAL_7D]			: PlanEnumDev.IFS_MAPPING_TRIAL_7D, //IFS mapping trial 7 days USD9

	[PlanEnum.GENOGRAM_CLASS_YEARLY]		: PlanEnumDev.GENOGRAM_CLASS_YEARLY, //genogram for class yearly 99, no trial
	[PlanEnum.GENOGRAM_YEARLY]				: PlanEnumDev.GENOGRAM_YEARLY, //genogram yearly 49, no trial
	[PlanEnum.GENOGRAM_MONTHLY]				: PlanEnumDev.GENOGRAM_MONTHLY, //genogram monthly 9, no trial

	[PlanEnum.GENOGRAM_MONTHLY_TRIAL]		: PlanEnumDev.GENOGRAM_MONTHLY_TRIAL, //genogram monthly 9, 7 days trial

	[PlanEnum.GENOGRAM_LIFETIME]			: PlanEnumDev.GENOGRAM_LIFETIME, //genogram lifetime 49

	[PlanEnum.PERSONAL_TOUCH_YEARLY]		: PlanEnumDev.PERSONAL_TOUCH_YEARLY, //Personal touch yearly 290, no trial
	[PlanEnum.PERSONAL_TOUCH_MONTHLY]		: PlanEnumDev.PERSONAL_TOUCH_MONTHLY, //Personal touch monthly 29, no trial

	[PlanEnum.ULTIMATE_YEARLY]				: PlanEnumDev.ULTIMATE_YEARLY, //Ultimate yearly 490, no trial
	[PlanEnum.ULTIMATE_YEARLY_DISCOUNT]		: PlanEnumDev.ULTIMATE_YEARLY_DISCOUNT, //Ultimate yearly 49, no trial

	[PlanEnum.PERSONAL_TOUCH_TRIAL]			: PlanEnumDev.PERSONAL_TOUCH_TRIAL, //Personal Touch 7 days trial 29

	[PlanEnum.WHEEL_OF_LIFE_TRIAL]			: PlanEnumDev.WHEEL_OF_LIFE_TRIAL, //Wheel of Life by Qwoach 14 days trial


	"897643": "72209", //genogram for class yearly 99, no trial
	"897164": "72072", //genogram yearly 49, no trial
	"895944": "72073", //genogram monthly 9, no trial

	"793798": "72382", //genogram monthly 9, 7 days trial

	"854620": "64942", //genogram lifetime 49

	"888193": "70054", //Personal touch yearly 290, no trial
	"850090": "70053", //Personal touch monthly 29, no trial

	"888194": "70056", //Ultimate yearly 490, no trial
	"883211": "70055", //Ultimate yearly 49, no trial


	"762957": "10550", //Personal Touch 7 days trial 29

	"898277": "72328", //Wheel of Life by Qwoach 14 days trial

}

export function mapPlanDev(planId, isDevEnvLocal){
	if((isDevEnvLocal || isDevEnv) && planId){
		planId = devPlanMapObj[planId] || planId
	}
	return planId
}
export function mapPlanDevReverse(planId, isDevEnvLocal){
	console.log("DevPlanMapper.mapPlanDevReverse: planId = ", planId, ", isDevEnvLocal = ", isDevEnvLocal, ", isDevEnv = ", isDevEnv)
	if((isDevEnvLocal || isDevEnv) && planId){
		for (let key in devPlanMapObj) {
			if (devPlanMapObj[key] === planId) {
				return key
			}
		}
	}
	return planId
}
